import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Components
import Location from '../Register/Location';

const LocationEdit = observer(class LocationEdit extends React.Component {
  render() {
    const { translation } = this.props;

    return(
      <div className="drawer__content">
        <header className="drawer__header">
          <div className="wrap">
            <h1 className="drawer__title">{translation.heading}</h1>
          </div>
        </header>

        <div className="wrap">
          <Location {...this.props} editing={true} />
        </div>
      </div>
    )
  }
})

export default translate('LocationEdit')(LocationEdit);


// WEBPACK FOOTER //
// ./src/app/components/Locations/Edit.js